import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBaseFormStore } from '../form-base-form/form-base-form.store';
import { FormBaseFormComponent } from '../form-base-form/form-base-form.component';
import { FormSetEnum } from '../../../../../../../../../types/src/services/enum/form-set.enum';
import { TranslatePipe } from '@ngx-translate/core';
import { TextInputComponent } from '../../../../../../components/kit/input/text-input/text-input.component';
import { DateInputComponent } from '../../../../../../components/kit/input/date-input/date-input.component';
import { CheckInputComponent } from '../../../../../../components/kit/input/check-input/check-input.component';
import {
    TextAreaInputComponent,
} from '../../../../../../components/kit/input/text-area-input/text-area-input.component';
import { SelectInputComponent } from '../../../../../../components/kit/input/select-input/select-input.component';
import { FormatPersonPipe } from '../../../../../shared/pipes/format-person.pipe';
import { ActionButtonsComponent } from '../../../../../../components/kit/action-buttons/action-buttons.component';

@Component({
    selector: 'app-form-opz-form',
    templateUrl: './form-opz-form.component.html',
    styleUrls: ['../form-base-form/form-base-form.scss'],
    providers: [FormBaseFormStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslatePipe,
        TextInputComponent,
        DateInputComponent,
        CheckInputComponent,
        TextAreaInputComponent,
        SelectInputComponent,
        FormatPersonPipe,
        ActionButtonsComponent,
    ],
})
export class FormOpzFormComponent extends FormBaseFormComponent implements OnInit {

    constructor() {
        super();

        this.formUniqueIdentifier = FormSetEnum.OPZ;

        this.generateForm([
            { name: 'transportWhere', defaultValue: null, required: false },
            { name: 'contactPersonOfWorkplace', defaultValue: null, required: false },
            {
                name: 'dateOfContract',
                defaultValue: new Date(),
                required: false,
                patchValueCallback: (date) => this.copy ? new Date() : new Date(date),
            },
            { name: 'completionOfExistingHistory', defaultValue: null, required: false },
            { name: 'allergy', defaultValue: null, required: false },
            { name: 'medicals', defaultValue: null, required: false },
            { name: 'food', defaultValue: null, required: false },
            { name: 'insulin', defaultValue: null, required: false },
            { name: 'lastWoundDressing', defaultValue: null, required: false },
            { name: 'lastStool', defaultValue: null, required: false },
            { name: 'other', defaultValue: null, required: false },
            { name: 'insuranceCard', defaultValue: false, required: false },
            { name: 'idCard', defaultValue: false, required: false },
            { name: 'incontinenceAids', defaultValue: false, required: false },
            { name: 'amountOfIncontinenceAids', defaultValue: null, required: false },
            { name: 'medicalDocumentation', defaultValue: false, required: false },
            { name: 'toiletries', defaultValue: false, required: false },
            { name: 'medicalsBool', defaultValue: false, required: false },
            { name: 'insulinBool', defaultValue: false, required: false },
            { name: 'glasses', defaultValue: false, required: false },
            { name: 'otherThings', defaultValue: null, required: false },
            { name: 'note', defaultValue: null, required: false },
        ], true);
    }
}
